import { format_ShortDOW_Date, getShiftTime, parsePreferredLeaveTime } from "./dateTimeFormatter";
import { isLWOPTOWOPDayOfRequest } from "./timeOffRequestUtils";

export const getTOREmployeeName = (timeOffRequest) => {
  return `${timeOffRequest.empLastName}, ${timeOffRequest.empFirstName}`;
};

export const getTOREmployeeId = (timeOffRequest) => {
  return timeOffRequest.empId;
};

export const getTORShift = (timeOffRequest) => {
  return (
    format_ShortDOW_Date(timeOffRequest.shiftStart) +
    " " +
    getShiftTime(timeOffRequest.shiftStart) +
    "-" +
    getShiftTime(timeOffRequest.shiftEnd)
  );
};

export const getTORstation = (timeOffRequest) => {
  return timeOffRequest.station;
};

export const getTORPreferredLeaveTime = (timeOffRequest) => {
  if (isLWOPTOWOPDayOfRequest(timeOffRequest.timeOffRequestType)) {
    return timeOffRequest.wopASAP
      ? "ASAP"
      : parsePreferredLeaveTime(timeOffRequest.preferredWOPStart, timeOffRequest.preferredWOPEnd);
  }
  return "";
};

export const getTORApprovedLeaveTime = (timeOffRequest) => {
  return parsePreferredLeaveTime(timeOffRequest.approvedWOPStart, timeOffRequest.approvedWOPEnd);
};
